import { render } from "./TotalRewardValue.vue?vue&type=template&id=7d703cc6"
import script from "./TotalRewardValue.vue?vue&type=script&lang=js"
export * from "./TotalRewardValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__